import * as React from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import Banner from "../components/Banner/Banner";
import ProjectSection from "../components/ProjectSection";
import ContactUsForm from "../components/ContactUsForm";
import Footer from "../components/Footer";
import QuoteSection from "../components/Quotes/QuoteSection";
import TeamsSection from "../components/Teams/TeamsSection";
import ScrollToTop from "../components/ScrollToTop";
import { Helmet } from "react-helmet";

const IndexPage = () => (
  <main id="main-content" className="w-full overflow-x-hidden">
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:left-4 focus:top-4 focus:bg-white focus:text-black focus:px-4 focus:py-2 focus:rounded-md focus:shadow-lg"
    >
      Skip to content
    </a>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Kuhaku | RIP (2020-2023)</title>
      <meta
        name="description"
        content="A postmortem of Kuhaku: where dreams went to die but the work lived to tell the tale. Archived portfolio & team legacy."
      />
      <link rel="canonical" title="Kuhaku" href="http://www.kuhaku.tech" />
    </Helmet>
    <Navbar />
    <HeroSection></HeroSection>
    <Banner id="about" theme="philosophy">
      <Banner.Header>
        Our <b>eulogy</b>, your entertainment
      </Banner.Header>
      <Banner.Body>
        Kuhaku started with unlimited ambition and a finite runway.
        <br /> This page preserves the wild ride, the lessons learned, and the memes made along the way.
      </Banner.Body>
    </Banner>
    <ProjectSection id="works"></ProjectSection>
    <Banner theme="passion">
      <Banner.Header>
        Our <b>legacy</b>, your inspiration (or warning)
      </Banner.Header>
      <Banner.Body>
        The company met its maker, but the work remains.
        <br /> Use this as proof that something real was built, shipped, and cherished—even if the bank account wasn't.
      </Banner.Body>
    </Banner>
    <QuoteSection id="testimony"></QuoteSection>
    <TeamsSection id="team"></TeamsSection>
    <ContactUsForm id="archive"></ContactUsForm>
    <Footer>
      <Footer.SocialItem
        asset={<i className="fa fa-linkedin text-white"></i>}
        hyperlink="https://www.linkedin.com/company/kuhaku"
      ></Footer.SocialItem>
      <Footer.SocialItem
        asset={<i className="fa fa-twitter text-white"></i>}
        hyperlink="https://twitter.com/KuhakuTech"
      ></Footer.SocialItem>
    </Footer>
    <ScrollToTop />
  </main>
);

export default IndexPage;
